import React, { useState } from "react";
import "./FundishHigher.css";

const FundishHigher = ({ data }) => {
  const [FundsHigh] = useState(data);
  return (
    <div className="boxtableFundishAlert">
      <table className="tableFundishAlerts">
        <thead>
          <tr>
            <th className="tableFundishHeader">Usuario</th>
            <th className="tableFundishHeader">Dni / Cuil</th>
            <th className="tableFundishHeader">Relacion con la Mutual</th>
            <th className="tableFundishHeader">Mes</th>
            <th className="tableFundishHeader">Excedente</th>
          </tr>
        </thead>
        <tbody>
          {FundsHigh.map((item, index) => {
            return (
              <tr key={index}>
                <td className="tableFundishData">{item.userName}</td>
                <td className="tableFundishData">{item.identify}</td>
                <td className="tableFundishData">{item.relation}</td>
                <td className="tableFundishData">{item.month}</td>
                <td className="tableFundishData">{item.exceededAmount}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FundishHigher;
